import script from "./FormPaymentsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPaymentsComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormPaymentsComponent.vue?vue&type=style&index=0&id=58ea8209&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ea8209"]])

export default __exports__